if (!customElements.get('petite-trace-header')) {
  customElements.define(
    'petite-trace-header',
    class PetiteTraceHeader extends HTMLElement {
      constructor() {
        super();
        this.toggleBtn = this.querySelector('[data-pt-menu-toggle]');
        this.closeBtn = this.querySelector('[data-pt-menu-close]');
        this.cartCount = this.querySelector('[data-pt-cart-count]');

        this.toggleBtn.addEventListener('click', () => this.classList.add('pt-is-open'));
        this.closeBtn.addEventListener('click', () => this.classList.remove('pt-is-open'));

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refreshCount());
        }
      }

      /* On relit le total réel du panier plutôt que d'incrémenter l'affichage :
         l'incrément se désynchronise dès que le panier change ailleurs
         (autre onglet, suppression d'article, mise à jour de quantité). */
      refreshCount() {
        if (!this.cartCount) return;
        fetch(window.routes && window.routes.cart_url ? window.routes.cart_url + '.js' : '/cart.js')
          .then((r) => r.json())
          .then((cart) => {
            this.cartCount.textContent = String(cart.item_count);
          })
          .catch(() => {
            /* Silencieux : un compteur périmé ne doit pas casser la page. */
          });
      }
    }
  );
}
